/* eslint @typescript-eslint/triple-slash-reference: "off" */
/// <reference types="gsap"/>
import * as React from "react";
import * as ReactDOM from "react-dom";
import gsap from "gsap";
/* eslint @typescript-eslint/no-explicit-any: "off" */
export class Animate extends React.Component {
    componentDidMount() {
        this.props.runOnMount && this.animate(this.props.animation);
    }
    componentDidUpdate() {
        this.animate(this.props.animation);
    }
    animate(animation) {
        const node = this.findDOMNode();
        if (node) {
            this.tween = gsap.to(node, animation);
        }
    }
    /* eslint react/no-find-dom-node: "off" */
    findDOMNode() {
        /**
         * https://reactjs.org/docs/react-dom.html#finddomnode
         *
         * findDOMNode is an escape hatch used to access the underlying DOM node.
         * In most cases, use of this escape hatch is discouraged because it
         * pierces the component abstraction. It has been deprecated in StrictMode.
         */
        return ReactDOM.findDOMNode(this);
    }
    render() {
        return this.props.children;
    }
}
//# sourceMappingURL=Animate.js.map